export default "__VITE_ASSET__CXGMzI66__"